import { isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'
import { PAYMENT_OPTIONS } from 'constants/payment'
import { createSelector } from 'reselect'
import getDepositServiceFee from './deposit/getDepositServiceFee'
import { getPaymentScheduleTotalServiceFee } from './paymentSchedule'
import getDynamicPaymentScheduleServiceFee from './paymentSchedule/getDynamicPaymentScheduleServiceFee'

const getServiceFeeAmount = createSelector(
  (state: App.State) => getDepositServiceFee(state),
  (state: App.State) => getPaymentScheduleTotalServiceFee(state),
  (state: App.State) => getDynamicPaymentScheduleServiceFee(state),
  (state: App.State) => state.checkout.payment.paymentSelected,
  (
    depositServiceFee,
    paymentScheduleServiceFee,
    dynamicPaymentScheduleServiceFee,
    paymentSelected,
  ): number => {
    if (paymentSelected === PAYMENT_OPTIONS.DEPOSIT) {
      return isAgentHubEnabled ? 0 : depositServiceFee
    } else if (paymentSelected === PAYMENT_OPTIONS.PAYMENT_SCHEDULE) {
      return paymentScheduleServiceFee
    } else if (paymentSelected === PAYMENT_OPTIONS.DYNAMIC_PAYMENT_SCHEDULE) {
      return dynamicPaymentScheduleServiceFee
    }
    return 0
  },
)

export default getServiceFeeAmount
